import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const WishlistContext = createContext(null);
export const useWishlist = () => useContext(WishlistContext);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  const refresh = useCallback(async () => {
    if (!user || user.role !== "buyer") { setIds([]); return; }
    try {
      const { data } = await api.get("/wishlist");
      setIds(data.product_ids || []);
    } catch { /* ignore */ }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const toggle = async (productId) => {
    const { data } = await api.post("/wishlist/toggle", { product_id: productId });
    setIds(data.product_ids || []);
    return data.hearted;
  };

  const isHearted = (id) => ids.includes(id);

  return (
    <WishlistContext.Provider value={{ ids, toggle, isHearted, refresh }}>
      {children}
    </WishlistContext.Provider>
  );
}
